import { IError } from '@checkout/errors';
import { RootState } from '@checkout/state';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { DispatchProp, connect } from 'react-redux';
import messages from './../i18n/base-en';

interface IErrorBoundaryProps {
  errors: IError;
}

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<IErrorBoundaryProps & DispatchProp<any> & InjectedIntlProps, ErrorBoundaryState> {

 state: ErrorBoundaryState = {
   hasError: false,
 };

 componentDidCatch(error: Error, info: object) {
   this.setState({ hasError: true });
   // this.props.setErrors({ errors, hasError: true });
   // TODO: think about bugsnag here
 }

 componentWillMount() {
   // const { error: hasError } = this.props.errors;
   // this.setState({ hasError });
 }

 render() {
   const { intl, children } = this.props;
   // const { message, stack } = remainingProps.errors;
   const { hasError } = this.state;
   const { formatMessage } = intl;

   if (hasError) {
     return (
       <div> {/* TODO make a component */}
         <h1>{formatMessage(messages.error_header)}</h1>
       </div>
     );
   }
   return children;
 }
}

const mapStateToProps = (state: RootState) => ({ errors: state.checkout.errors });

export default injectIntl<any>(connect(mapStateToProps)(ErrorBoundary));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/wrappers/ErrorBoundary.tsx